import { getServicesClient } from "@/api/clients/api-client";

export const deleteEmployee = async (userId: string) => {
  const res = await getServicesClient().delete(`/users/${userId}`);

  return res.data;
};
